import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fd05eee6")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RecipeTopListItem = _resolveComponent("RecipeTopListItem")

  return (_openBlock(), _createBlock("div", {
    class: "recipe-image-view",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick(...args)))
  }, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getRecipes(_ctx.recipes), (recipe) => {
      return (_openBlock(), _createBlock(_component_RecipeTopListItem, {
        key: recipe.recipeId,
        recipeImageUrl: recipe.imageUrl,
        recipeLabel: recipe.title,
        recipeId: recipe.recipeId,
        groupId: recipe.groupId,
        recipeType: recipe.type,
        recipeApplianceCategory: recipe.applianceCategory,
        recipeApplianceCategoryId: recipe.applianceCategoryId,
        recipeFoodIds: recipe.foodIds,
        onSelectRecipe: _ctx.selectRecipe
      }, null, 8, ["recipeImageUrl", "recipeLabel", "recipeId", "groupId", "recipeType", "recipeApplianceCategory", "recipeApplianceCategoryId", "recipeFoodIds", "onSelectRecipe"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})